document.addEventListener('DOMContentLoaded', function () {
  var popupOverlay = document.querySelector('[data-prelaunch-popup-overlay]');

  function openPopup() {
    if (!popupOverlay) {
      return;
    }
    popupOverlay.classList.add('is-visible');
  }

  function closePopup() {
    if (!popupOverlay) {
      return;
    }
    popupOverlay.classList.remove('is-visible');
  }

  if (popupOverlay) {
    var closeButton = popupOverlay.querySelector('[data-prelaunch-popup-close]');
    if (closeButton) {
      closeButton.addEventListener('click', closePopup);
    }
    popupOverlay.addEventListener('click', function (event) {
      if (event.target === popupOverlay) {
        closePopup();
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closePopup();
      }
    });
  }

  document.querySelectorAll('[data-klaviyo-form]').forEach(function (form) {
    var companyId = form.dataset.klaviyoCompanyId;
    var listId = form.dataset.klaviyoListId;
    var input = form.querySelector('input[type="email"]');
    var messageEl = form.querySelector('[data-klaviyo-message]');
    var button = form.querySelector('button[type="submit"]');

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = input.value.trim();
      if (!email) {
        return;
      }

      button.disabled = true;
      if (messageEl) {
        messageEl.hidden = true;
      }

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + companyId, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2024-10-15',
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                  },
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: listId,
                },
              },
            },
          },
        }),
      })
        .then(function (response) {
          button.disabled = false;
          if (response.ok) {
            form.reset();
            input.blur();
            openPopup();
          } else if (messageEl) {
            messageEl.textContent = 'Something went wrong. Please try again.';
            messageEl.hidden = false;
          }
        })
        .catch(function () {
          button.disabled = false;
          if (messageEl) {
            messageEl.textContent = 'Something went wrong. Please try again.';
            messageEl.hidden = false;
          }
        });
    });
  });
});
